import { EInvoiceAttachment } from '../../../../data/models'
import {
  ControlInformation,
  UblInvoice,
} from '../../../../data/models/_generatedUblInvoice'

interface EInvoiceHistoryControlInformation {
  processingType: ControlInformation['processingType']
  trialFlag: ControlInformation['trialFlag']
}

interface EInvoiceHistoryMeta {
  controlInformation: EInvoiceHistoryControlInformation
}

export interface EInvoiceHistory {
  id: string
  recipient: string
  invoiceNumber: string
  invoiceDate: string
  grossPrice: number
  invoiceType: UblInvoice['InvoiceTypeCode']['Value']
  documentName: string
  submittedAt: string
  submittedBy: string
  status: EInvoiceHistoryStatus
  attachments: EInvoiceAttachment[]
  meta: EInvoiceHistoryMeta
}

export enum EInvoiceHistoryStatus {
  Submitted = 0,
}

export enum EInvoiceTargetFormat {
  Request_for_payment = 0,
  Debit_note_related_to_goods_or_services = 1,
  Credit_note_related_to_goods_or_services = 2,
  Metered_services_invoice = 3,
  Credit_note_related_to_financial_adjustments = 4,
  Debit_note_related_to_financial_adjustments = 5,
  Tax_notification = 6,
  Invoicing_data_sheet = 7,
  Direct_payment_valuation = 8,
  Provisional_payment_valuation = 9,
  Payment_valuation = 10,
  Interim_application_for_payment = 11,
  Final_payment_request_based_on_completion_of_work = 12,
  Payment_request_for_completed_units = 13,
  Self_billed_credit_note = 14,
  Consolidated_credit_note_goods_and_services = 15, // modified due to hyphen
  Price_variation_invoice = 16,
  Credit_note_for_price_variation = 17,
  Delcredere_credit_note = 18,
  Proforma_invoice = 19,
  Partial_invoice = 20,
  Commercial_invoice_which_includes_a_packing_list = 21,
  Commercial_invoice = 22,
  Credit_note = 23,
  Commission_note = 24,
  Debit_note = 25,
  Corrected_invoice = 26,
  Consolidated_invoice = 27,
  Prepayment_invoice = 28,
  Hire_invoice = 29,
  Tax_invoice = 30,
  Self_billed_invoice = 31,
  Delcredere_invoice = 32,
  Factored_invoice = 33,
  Lease_invoice = 34,
  Consignment_invoice = 35,
  Factored_credit_note = 36,
  Optical_Character_Reading_OCR_payment_credit_note = 37, // modified due to parentheses
  Debit_advice = 38,
  Reversal_of_debit = 39,
  Reversal_of_credit = 40,
  Self_billed_debit_note = 41,
  Forwarders_credit_note = 42, // modified due to apostrophe
  Forwarders_invoice_discrepancy_report = 43, // modified due to apostrophe
  Insurers_invoice = 44, // modified due to apostrophe
  Forwarders_invoice = 45, // modified due to apostrophe
  Port_charges_documents = 46,
  Invoice_information_for_accounting_purposes = 47,
  Freight_invoice = 48,
  Claim_notification = 49,
  Consular_invoice = 50,
  Partial_construction_invoice = 51,
  Partial_final_construction_invoice = 52,
  Final_construction_invoice = 53,
  Customs_invoice = 54,
}
